export default {
  formulario: state => state.formulario,
  flagsDeControle: state => state.flagsDeControle
}
